import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <g data-name="Designed by Freepik">
        <g data-name="Group 1846">
          <g data-name="Ellipse 88">
            <circle cx={25} cy={25} r={24.46} fill={props.fillPrimary} />
            <circle
              cx={25}
              cy={25}
              r={23.78}
              fill="none"
              stroke={props.fillPrimary}
              strokeWidth={1.36}
            />
          </g>
          <path
            data-name="Path 5397"
            d="M36.51 33.56a4.19 4.19 0 11-8.37.36v-.36a4.46 4.46 0 01.12-1L20.59 28a4.1 4.1 0 01-2.91 1.23 4.37 4.37 0 010-8.74 4.06 4.06 0 012.91 1.23l7.67-4.57a4.55 4.55 0 01-.12-1 4.19 4.19 0 114.19 4.38A4.11 4.11 0 0129.25 19l-7.57 4.51a4.61 4.61 0 010 2.55l7.57 4.51a4.1 4.1 0 013.08-1.41 4.28 4.28 0 014.18 4.4z"
            fill={props.fillSecondary}
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
